export const SOLANA_ALPHA_MAX_TRADE_SIZE_USD = 10_000

export const SOLANA_ALPHA_MAX_TRADE_SIZE_USD_DISPLAY = SOLANA_ALPHA_MAX_TRADE_SIZE_USD.toLocaleString('en-US')
